


















import { Component, Vue, Prop } from 'vue-property-decorator';
import { CourseChange } from '@/domains/course';

@Component({ name: 'CourseChangeDialog' })
export default class CourseChangeDialog extends Vue {
  /** bus */
  @Prop()
  private bus: Vue;

  private visible: boolean = false;

  private list: CourseChange[] = null;

  private handler() {
    this.bus.$on('course-change-dialog', (list: CourseChange[]) => {
      this.list = list;
      this.visible = true;
    });
  }

  private mounted() {
    this.handler();
  }
}
